
  const __registry__ = require('../../../spiferack/client/index.js')
  'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = require('prop-types');
var Link = require('@npm/spiferack/link');

var SimplePagination = require('../../components/pagination/simple-pagination');
var types = require('../../types');
var PackageList = require('../../components/package-list/package-list');
var styles = require('./package-list.css');

var PackageListPage = function (_React$Component) {
  _inherits(PackageListPage, _React$Component);

  function PackageListPage() {
    _classCallCheck(this, PackageListPage);

    return _possibleConstructorReturn(this, (PackageListPage.__proto__ || Object.getPrototypeOf(PackageListPage)).apply(this, arguments));
  }

  _createClass(PackageListPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          dependency = _props.dependency,
          packages = _props.packages,
          url = _props.url,
          paginationSize = _props.paginationSize,
          hasNext = _props.hasNext,
          hasPrev = _props.hasPrev;

      return React.createElement(
        'div',
        { className: 'center mw7 w-100 pt3 pb4' },
        React.createElement(
          'h1',
          { className: styles.header },
          title,
          ' ',
          dependency ? React.createElement(
            Link,
            null,
            React.createElement(
              'a',
              { className: 'link', href: '/package/' + dependency },
              dependency
            )
          ) : ''
        ),
        React.createElement(PackageList, { packages: packages }),
        React.createElement(SimplePagination, { url: url, paginationSize: paginationSize, hasPrev: hasPrev, hasNext: hasNext })
      );
    }
  }]);

  return PackageListPage;
}(React.Component);

PackageListPage.propTypes = {
  packages: PropTypes.arrayOf(types.packageListItem).isRequired
};

module.exports = PackageListPage;
  let __hot__
  
  __registry__.register('package-list/package-list', module.exports, __hot__)
  